import { globalTheme } from "../../styles";

export const AdvancedSearchIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = globalTheme.primaryColor } = props;
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 52 52"
      enableBackground="new 0 0 52 52"
      xmlSpace="preserve"
    >
      <g>
        <path
          d="M24.4,31.8c-0.6-0.6-1.5-0.6-2.1,0l-3.6,3.6C18.1,36,17,35.6,17,34.7V21.5c0-0.8-0.7-1.5-1.5-1.5h-3
		c-0.8,0-1.5,0.7-1.5,1.5v13.2c0,0.9-1.1,1.3-1.7,0.7l-3.6-3.6c-0.6-0.6-1.5-0.6-2.1,0L1.4,34c-0.6,0.6-0.6,1.5,0,2.1l11.5,11.5
		c0.6,0.6,1.5,0.6,2.1,0L26.6,36c0.6-0.6,0.6-1.5,0-2.1L24.4,31.8z"
        />
        <path
          d="M51,9.5C51,8.7,50.3,8,49.5,8h-37C11.7,8,11,8.7,11,9.5v3c0,0.8,0.7,1.5,1.5,1.5h37c0.8,0,1.5-0.7,1.5-1.5
		V9.5z"
        />
        <path
          d="M51,21.5c0-0.8-0.7-1.5-1.5-1.5h-27c-0.8,0-1.5,0.7-1.5,1.5v3c0,0.8,0.7,1.5,1.5,1.5h27
		c0.8,0,1.5-0.7,1.5-1.5V21.5z"
        />
        <path
          d="M51,33.5c0-0.8-0.7-1.5-1.5-1.5h-17c-0.8,0-1.5,0.7-1.5,1.5v3c0,0.8,0.7,1.5,1.5,1.5h17
		c0.8,0,1.5-0.7,1.5-1.5V33.5z"
        />
      </g>
    </svg>
  );
};
